import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming It: “I Shrink So They Won’t Leave”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop blaming myself. I recognize a pattern: I become smaller in order to stay."
    ],
      [
      "Daily intention: Today I stop blaming myself. I recognize a pattern: I become smaller in order to stay."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This fear is trying to protect me, not to control me.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This fear is trying to protect me, not to control me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "I ask myself:\nWhat do I do to be “okay” in my partner’s eyes?\n[Write here]",
      "I ask myself:\nWhere don’t I allow myself to be me?\n[Write here]",
      "I ask myself:\nWhat does the fear tell me will happen if I’m authentic?\n[Write here]"
    ],
      [
      "I ask myself:\nWhat do I do to be “okay” in my partner’s eyes?\n[Write here]",
      "I ask myself:\nWhere don’t I allow myself to be me?\n[Write here]",
      "I ask myself:\nWhat does the fear tell me will happen if I’m authentic?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Today I see the pattern — without fighting it."
    ],
      [
      "Closing",
      "Today I see the pattern — without fighting it."
    ]
    ),
    action: localizedGenderNode(
      "Once today: one breath + the sentence in my heart: “I can be myself, even a little.”",
      "Once today: one breath + the sentence in my heart: “I can be myself, even a little.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Story vs. Fact: What Is the Real Danger?",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate an old fear from what is happening now."
    ],
      [
      "Daily intention: Today I separate an old fear from what is happening now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Not every fear is a fact.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Not every fear is a fact.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the plain fact? (what actually happened, without interpretation)\n[Write here]",
      "What story does my mind tell? (“If I say…, they’ll leave me”)\n[Write here]",
      "What does it do to my body when I believe the story?\n[Write here]",
      "What gentle truth can I choose today?\n[Write here]"
    ],
      [
      "What is the plain fact? (what actually happened, without interpretation)\n[Write here]",
      "What story does my mind tell? (“If I say…, they’ll leave me”)\n[Write here]",
      "What does it do to my body when I believe the story?\n[Write here]",
      "What gentle truth can I choose today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Not every thought is true. Sometimes it’s just fear asking for safety."
    ],
      [
      "Closing",
      "Not every thought is true. Sometimes it’s just fear asking for safety."
    ]
    ),
    action: localizedGenderNode(
      "Once today: “That’s a story, not a fact.” + one breath.",
      "Once today: “That’s a story, not a fact.” + one breath."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Urge to Please (90-Second Protocol)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I build a pause before “people-pleasing.”"
    ],
      [
      "Daily intention: Today I build a pause before “people-pleasing.”"
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I choose me first.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I choose me first.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I people-please the most? (silence / agreement / apology / giving up)\n[Write here]",
      "What am I trying to prevent through pleasing? (anger / abandonment / criticism / distance)\n[Write here]",
      "90-second protocol (from today onward)\n\n1. 3 slow breaths\n\n2. Notice the body: where does the fear sit\n\n3. Sentence in my heart: “This is fear. It will pass.”\nThen choose one small alternative.\n\n\nWhich one alternative do I choose today instead of pleasing?\n[Write here]"
    ],
      [
      "Where do I people-please the most? (silence / agreement / apology / giving up)\n[Write here]",
      "What am I trying to prevent through pleasing? (anger / abandonment / criticism / distance)\n[Write here]",
      "90-second protocol (from today onward)\n\n1. 3 slow breaths\n\n2. Notice the body: where does the fear sit\n\n3. Sentence in my heart: “This is fear. It will pass.”\nThen choose one small alternative.\n\n\nWhich one alternative do I choose today instead of pleasing?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to please in order to be loved."
    ],
      [
      "Closing",
      "I don’t have to please in order to be loved."
    ]
    ),
    action: localizedGenderNode(
      "Once today — the 90-second protocol before an automatic “yes.”",
      "Once today — the 90-second protocol before an automatic “yes.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Where I Disappear in the Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see where I give myself up in order to keep the relationship."
    ],
      [
      "Daily intention: Today I see where I give myself up in order to keep the relationship."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “My life is not meant to shrink in order to be together.”"
    ],
      [
      "I pause with myself.",
      "One breath. “My life is not meant to shrink in order to be together.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I feel I’m “conditional”?\n[Write here]",
      "Which part of me do I hide? (want / pain / opinion / boundary)\n[Write here]",
      "What price do I pay for hiding?\n[Write here]"
    ],
      [
      "Where do I feel I’m “conditional”?\n[Write here]",
      "Which part of me do I hide? (want / pain / opinion / boundary)\n[Write here]",
      "What price do I pay for hiding?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "If I disappear — the relationship isn’t truly holding me."
    ],
      [
      "Closing",
      "If I disappear — the relationship isn’t truly holding me."
    ]
    ),
    action: localizedGenderNode(
      "I write one sentence of truth about me — only for myself.",
      "I write one sentence of truth about me — only for myself."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Shame: “If They See Me, They Won’t Want Me”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch shame without letting it control me."
    ],
      [
      "Daily intention: Today I touch shame without letting it control me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Shame wants me to hide. Today I stay.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Shame wants me to hide. Today I stay.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the harshest sentence that rises in me about myself?\n[Write here]",
      "If a beloved friend said that about themselves — what would I tell them?\n[Write here]",
      "What is one gentle sentence I’m willing to tell myself today?\n[Write here]"
    ],
      [
      "What is the harshest sentence that rises in me about myself?\n[Write here]",
      "If a beloved friend said that about themselves — what would I tell them?\n[Write here]",
      "What is one gentle sentence I’m willing to tell myself today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Shame doesn’t speak truth. It says it hurts to be seen."
    ],
      [
      "Closing",
      "Shame doesn’t speak truth. It says it hurts to be seen."
    ]
    ),
    action: localizedGenderNode(
      "Hand on chest/belly (if it feels okay) + one gentle sentence only.",
      "Hand on chest/belly (if it feels okay) + one gentle sentence only."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Where It Comes From (A Gentle Root)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I understand: the fear didn’t start in this relationship."
    ],
      [
      "Daily intention: Today I understand: the fear didn’t start in this relationship."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “This is an old pattern being activated now.”"
    ],
      [
      "I pause with myself.",
      "One breath. “This is an old pattern being activated now.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When in my life did I learn that being me is dangerous?\n[Write here]",
      "What did I need back then and didn’t receive?\n[Write here]",
      "What do I need today to feel safe enough to bring myself forward?\n[Write here]"
    ],
      [
      "When in my life did I learn that being me is dangerous?\n[Write here]",
      "What did I need back then and didn’t receive?\n[Write here]",
      "What do I need today to feel safe enough to bring myself forward?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "It’s not my fault this fear formed in me. But I can care for it."
    ],
      [
      "Closing",
      "It’s not my fault this fear formed in me. But I can care for it."
    ]
    ),
    action: localizedGenderNode(
      "I write: “Today I’m an adult. I can protect me.”",
      "I write: “Today I’m an adult. I can protect me.”"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A Small Truth (Clean Exposure)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice bringing a small truth without flooding."
    ],
      [
      "Daily intention: Today I practice bringing a small truth without flooding."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Not everything. Just one small, real thing.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Not everything. Just one small, real thing.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small truth do I usually hide?\n[Write here]",
      "What is my fear if I say it?\n[Write here]",
      "How can I say it in a soft and clear way? (one sentence)\n[Write here]"
    ],
      [
      "What small truth do I usually hide?\n[Write here]",
      "What is my fear if I say it?\n[Write here]",
      "How can I say it in a soft and clear way? (one sentence)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Courage is not drama. Courage is one sentence."
    ],
      [
      "Closing",
      "Courage is not drama. Courage is one sentence."
    ]
    ),
    action: localizedGenderNode(
      "I write my “small truth” sentence and practice saying it out loud (alone).",
      "I write my “small truth” sentence and practice saying it out loud (alone)."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "One Soft Boundary (Without Over-Apologizing)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I set one small boundary that protects me."
    ],
      [
      "Daily intention: Today I set one small boundary that protects me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “A boundary is protection, not a threat.”"
    ],
      [
      "I pause with myself.",
      "One breath. “A boundary is protection, not a threat.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What one boundary is missing for me in the relationship?\n[Write here]",
      "What is my fear if I set it?\n[Write here]",
      "What is a gentle answer to that fear?\n[Write here]",
      "How do I phrase the boundary in first person?\n[Write here]"
    ],
      [
      "What one boundary is missing for me in the relationship?\n[Write here]",
      "What is my fear if I set it?\n[Write here]",
      "What is a gentle answer to that fear?\n[Write here]",
      "How do I phrase the boundary in first person?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Someone who loves me needs to meet me — not a reduced version of me."
    ],
      [
      "Closing",
      "Someone who loves me needs to meet me — not a reduced version of me."
    ]
    ),
    action: localizedGenderNode(
      "I choose one small boundary for this week, even if only inside me.",
      "I choose one small boundary for this week, even if only inside me."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Not Asking for “Permission to Exist”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop waiting for approval to feel legitimate."
    ],
      [
      "Daily intention: Today I stop waiting for approval to feel legitimate."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “My existence doesn’t require approval.”"
    ],
      [
      "I pause with myself.",
      "One breath. “My existence doesn’t require approval.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I seek basic approval?\n[Write here]",
      "What do I do when I don’t receive it?\n[Write here]",
      "What permission do I give myself today? (one sentence)\n[Write here]"
    ],
      [
      "Where do I seek basic approval?\n[Write here]",
      "What do I do when I don’t receive it?\n[Write here]",
      "What permission do I give myself today? (one sentence)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I can be me even when the response isn’t perfect."
    ],
      [
      "Closing",
      "I can be me even when the response isn’t perfect."
    ]
    ),
    action: localizedGenderNode(
      "Once today: I do one small thing “for me” without explaining.",
      "Once today: I do one small thing “for me” without explaining."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Fear of Abandonment During Conflict",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I learn to stay steady when there is tension."
    ],
      [
      "Daily intention: Today I learn to stay steady when there is tension."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Conflict doesn’t always mean abandonment.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Conflict doesn’t always mean abandonment.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens in my body when there is tension?\n[Write here]",
      "What do I do to calm it immediately? (please / shut down / attack)\n[Write here]",
      "What safety sentence can I say to myself in the middle of tension?\n[Write here]"
    ],
      [
      "What happens in my body when there is tension?\n[Write here]",
      "What do I do to calm it immediately? (please / shut down / attack)\n[Write here]",
      "What safety sentence can I say to myself in the middle of tension?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I can hold tension without disappearing."
    ],
      [
      "Closing",
      "I can hold tension without disappearing."
    ]
    ),
    action: localizedGenderNode(
      "In one mini-tension today: one breath + my safety sentence.",
      "In one mini-tension today: one breath + my safety sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "What I Need to Feel Safe in a Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I acknowledge my needs without shame."
    ],
      [
      "Daily intention: Today I acknowledge my needs without shame."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “A need is not weakness.”"
    ],
      [
      "I pause with myself.",
      "One breath. “A need is not weakness.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What are 3 basic needs of mine in a relationship?\n[Write here]",
      "Which need am I most afraid to ask for?\n[Write here]",
      "What is one simple way to ask for it?\n[Write here]"
    ],
      [
      "What are 3 basic needs of mine in a relationship?\n[Write here]",
      "Which need am I most afraid to ask for?\n[Write here]",
      "What is one simple way to ask for it?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "If I don’t know what I need — I will always be “conditional.”"
    ],
      [
      "Closing",
      "If I don’t know what I need — I will always be “conditional.”"
    ]
    ),
    action: localizedGenderNode(
      "I write one short request I’m willing to say (even if I don’t say it yet).",
      "I write one short request I’m willing to say (even if I don’t say it yet)."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "“If It Ends, I Still Stay With Me”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I strengthen my inner anchor."
    ],
      [
      "Daily intention: Today I strengthen my inner anchor."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I don’t disappear if a relationship ends.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I don’t disappear if a relationship ends.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What scares me most about the relationship ending?\n[Write here]",
      "What resources do I have (or can build) if it happens?\n[Write here]",
      "What return sentence do I want for hard days?\n[Write here]"
    ],
      [
      "What scares me most about the relationship ending?\n[Write here]",
      "What resources do I have (or can build) if it happens?\n[Write here]",
      "What return sentence do I want for hard days?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "My safety begins with staying with myself."
    ],
      [
      "Closing",
      "My safety begins with staying with myself."
    ]
    ),
    action: localizedGenderNode(
      "I choose one “anchor”: a call with a safe person / a walk / a small order in my space.",
      "I choose one “anchor”: a call with a safe person / a walk / a small order in my space."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Choosing a Leading Value (Not a Leading Fear)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I let a value lead me, not fear."
    ],
      [
      "Daily intention: Today I let a value lead me, not fear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Fear shouts. Values guide.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Fear shouts. Values guide.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What value do I want to bring into the relationship? (honesty / respect / gentleness / truth / stability)\n[Write here]",
      "What looks different when I act from that value?\n[Write here]",
      "What one small action this week expresses that value?\n[Write here]"
    ],
      [
      "What value do I want to bring into the relationship? (honesty / respect / gentleness / truth / stability)\n[Write here]",
      "What looks different when I act from that value?\n[Write here]",
      "What one small action this week expresses that value?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to build a relationship from survival."
    ],
      [
      "Closing",
      "I don’t have to build a relationship from survival."
    ]
    ),
    action: localizedGenderNode(
      "I write my value and place it where I can see it.",
      "I write my value and place it where I can see it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure: A Relationship That Doesn’t Require Me to Disappear",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I finish this journey without drama — with truth."
    ],
      [
      "Daily intention: Today I finish this journey without drama — with truth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath. “I return to me.”"
    ],
      [
      "I pause with myself.",
      "One slow breath. “I return to me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I understand about my pattern?\n[Write here]",
      "What is clearer to me now, even if it hurts?\n[Write here]",
      "A return sentence for days of abandonment fear (short and clear):\n[Write here]"
    ],
      [
      "What did I understand about my pattern?\n[Write here]",
      "What is clearer to me now, even if it hurts?\n[Write here]",
      "A return sentence for days of abandonment fear (short and clear):\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I don’t need a relationship where I live on conditions.",
      "I don’t have to disappear in order to be loved.",
      "I keep walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I don’t need a relationship where I live on conditions.",
      "I don’t have to disappear in order to be loved.",
      "I keep walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that symbolizes “I return to myself”: a small tidy-up / a walk in a new place / writing 5 lines in my journal.",
      "One action that symbolizes “I return to myself”: a small tidy-up / a walk in a new place / writing 5 lines in my journal."
    ),
  },
].map(buildNormalizedDay);

export const conditionalRelationshipFearOfAbandonmentBlueprintEn = buildNormalizedPilotBlueprint({
  id: "conditional_relationship_fear_of_abandonment_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "conditional_relationship_fear_of_abandonment",
  category: "general",
  journeyName: {
    he: "קשר שכל הזמן “על תנאי” (פחד שינטשו אותי אם אהיה אני)",
    en: "A Relationship That’s Always “Conditional” (Fear They’ll Leave If I’m Myself)",
    es: "Una relación siempre “condicional” (miedo a que me abandonen si soy yo)",
  },
  days,
});

export default conditionalRelationshipFearOfAbandonmentBlueprintEn;
